import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'

import environment from '@environment/'

const ReCaptchaV2 = ({ onChange, size }) => {
  const [token, setToken] = useState('')

  useEffect(() => {
    if (onChange) onChange(token)
  }, [onChange, token])

  return <ReCAPTCHA size={size} sitekey={environment.reCaptchaSiteKey} onChange={setToken} hl="pt-br" onExpired={setToken} onErrored={setToken} />
}

ReCaptchaV2.propTypes = {
  onChange: PropTypes.func,
  size: PropTypes.string,
}

export default ReCaptchaV2
